/**
 * Helper functions for delegation state management.
 */

import { insertEntityAfterParent } from './chat-entity-insertion.helper'
import type { ChatMessageEntity } from './chat-message-entity.interface'
import type { ChatState } from './chat-state.interface'

export interface StartDelegationPayload {
  itemId: string
  eventId: string
  conversationId: string
  supervisorId: string
  targetList: string[]
  targetLabelList: string[]
  task?: string
}

export const handleStartDelegation = (state: ChatState, payload: StartDelegationPayload): void => {
  const { itemId, conversationId, supervisorId, targetList, targetLabelList, task } = payload

  const entityId = `${itemId}-delegation-${Date.now()}`

  const delegationEntity: ChatMessageEntity = {
    id: entityId,
    conversationId,
    type: 'delegation',
    content: task ?? '',
    timestamp: new Date().toISOString(),
    supervisorId,
    delegationTargetList: targetList,
    delegationTargetLabelList: targetLabelList,
    delegationReport: task,
    isDelegationComplete: true,
    isPending: false,
    isStreaming: false,
    streamingContent: '',
  }

  insertEntityAfterParent({
    state,
    conversationId,
    parentEventId: itemId,
    entity: delegationEntity,
  })
}
